"use client";

import { isSaved, save } from "./actions";
import type { SaveType } from "@prisma/client";
import { useEffect, useState, useRef } from "react";
import { SavedIcon } from "./icons/SavedIcon";
import { UnsavedIcon } from "./icons/UnsavedIcon";

interface Props {
  type: SaveType;
  id: string;
  subId?: string;
}

export default function SaveButton({ type, id, subId }: Props) {
  const [saved, setSaved] = useState<boolean>();
  const [isInView, setIsInView] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsInView(true);
          observer.disconnect(); // 一度観測したら停止
        }
      },
      {
        threshold: 0.1, // 10%表示されたらトリガー
        rootMargin: "0px", // 必要に応じて調整
      },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    console.log(ref.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isInView) {
      isSaved(type, id).then((ret) => {
        setSaved(ret);
      });
    }
  }, [type, id, isInView]);

  const submit = async (bool: boolean) => {
    setSaved(bool);
    await save(type, id, bool, subId);
  };

  return (
    <div ref={ref}>
      {saved !== undefined && (
        <button
          type="button"
          onClick={() => {
            submit(!saved);
          }}
        >
          <div className="h-[38px] w-[38px] rounded-[20px] bg-variable-collection-white shadow-[8px_16px_48px_#00000033]">
            {saved ? (
              <SavedIcon className="!absolute !left-[9px] !top-[9px] !h-[20px] !w-[20px]" />
            ) : (
              <UnsavedIcon className="!absolute !left-[9px] !top-[9px] !h-[20px] !w-[20px]" />
            )}
          </div>
        </button>
      )}
    </div>
  );
}
